import { render } from "./AddInformation.vue?vue&type=template&id=26bcc413&scoped=true"
import script from "./AddInformation.vue?vue&type=script&lang=js"
export * from "./AddInformation.vue?vue&type=script&lang=js"

import "./AddInformation.vue?vue&type=style&index=0&id=26bcc413&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bcc413"]])

export default __exports__